<div class="container">

  <app-header 
    (signOut)="logout()" 
    [islogin]="islogin">
  </app-header>

  <div class="content" role="main" style="width: 95%;">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>

</div>
